import React, { Component } from 'react'
import TribalP from '../tribal.jpg';

import { Jumbotron } from 'react-bootstrap';


export class Tribal extends Component {
    render() {
        return (
            <div>
                 <Jumbotron  style = {{margin:"5%"}}>
  
    <img
      className="d-block w-100"
      src={TribalP}
      alt="First slide"
    />
    </Jumbotron>
 


  
            </div>
        )
    }
}

    export default Tribal